import Louise1 from '../../../media/Residentials/Louise/Louise (1).webp'
import Louise2 from '../../../media/Residentials/Louise/Louise (2).webp'
import Louise3 from '../../../media/Residentials/Louise/Louise (3).webp'
import Louise4 from '../../../media/Residentials/Louise/Louise (4).webp'
import Louise5 from '../../../media/Residentials/Louise/Louise (5).webp'
import Louise6 from '../../../media/Residentials/Louise/Louise (6).webp'
import Louise7 from '../../../media/Residentials/Louise/Louise (7).webp'
import Louise8 from '../../../media/Residentials/Louise/Louise (8).webp'
import Louise9 from '../../../media/Residentials/Louise/Louise (9).webp'
import Louise10 from '../../../media/Residentials/Louise/Louise (10).webp'


const Louiseimages =[
Louise1,Louise2,Louise3,Louise4,Louise5,Louise6,Louise7,Louise8,Louise9,Louise10
]

export default Louiseimages;